import SILP from '../images/SILP.png'
export const projectsData = [
	{
		id: 114,
		title: 'SellerChamp',
		category: 'Full Stack Application',
		img: "https://media.licdn.com/dms/image/v2/C561BAQEFhdH2dAxJbg/company-background_10000/company-background_10000/0/1627222610384/sellerchamp_cover?e=2147483647&v=beta&t=hAu0HfTBrnFM7pd20lAp5hqMepA_qxxZYgA88TR3ddI",
	},
	{
		id: 115,
		title: 'EngineHire',
		category: 'Full Stack Application',
		img: "https://enginehire.io/wp-content/uploads/2023/12/enginehire-logo-thin-dark-1.0-letterpaths.svg",
	},
	{
		id: 116,
		title: 'Glocal',
		category: 'Full Stack Application',
		img: "https://techcrunch.com/wp-content/uploads/2012/11/glocal3.jpg",
	},
	{
		id: 101,
		title: 'Student Industry Linkage Portal for NED University',
		category: 'Full Stack Application',
		img: SILP,
	},
	{
		id: 108,
		title: 'EthTransfer',
		category: 'Blockchain Application',
		img: "https://user-images.githubusercontent.com/63925374/226187649-9635d665-7622-43b9-9b07-cfb9acec3368.png",
	},
	{
		id: 109,
		title: 'BitPred',
		category: 'Machine Learning',
		img: "https://imageio.forbes.com/specials-images/imageserve/608a09fbe9d77bad4722fe56/Bitcoin-Stock-to-Flow-Model/0x0.jpg?height=393&width=711&fit=bounds",
	},


	// {
	// 	id: 2,
	// 	title: 'Pharmacy POS',
	// 	category: 'Desktop Application',
	// 	img: MobileImage2,
	// },
	// {
	// 	id: 3,
	// 	title: 'Phoenix Digital Agency',
	// 	category: 'Web3 Application',
	// 	img: UIImage1,
	// },
	// {
	// 	id: 4,
	// 	title: 'Cloud Storage Platform',
	// 	category: 'Web3 Application',
	// 	img: UIImage2,
	// },
	// {
	// 	id: 5,
	// 	title: 'React Social App',
	// 	category: 'Web3 Application',
	// 	img: MobileImage1,
	// },
	// {
	// 	id: 6,
	// 	title: 'Apple Design System',
	// 	category: 'Web3 Application',
	// 	img: WebImage1,
	// },
	// {
	// 	id: 7,
	// 	title: 'example ABC',
	// 	category: 'Web3 Application',
	// 	img: UIImage1,
	// },
	// {
	// 	id: 8,
	// 	title: 'example DEF',
	// 	category: 'Mobile Application',
	// 	img: UIImage2,
	// },
];
